import { render, staticRenderFns } from "./AMStudentForm.vue?vue&type=template&id=45262641&scoped=true&"
import script from "./AMStudentForm.vue?vue&type=script&lang=js&"
export * from "./AMStudentForm.vue?vue&type=script&lang=js&"
import style0 from "./AMStudentForm.vue?vue&type=style&index=0&id=45262641&prod&scoped=true&lang=scss&"
import style1 from "./AMStudentForm.vue?vue&type=style&index=1&id=45262641&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45262641",
  null
  
)

export default component.exports